import { useAsync } from 'core/ui/hooks/useAsync'

import { refreshInviteToken as refreshInviteTokenUseCase } from '../../use-cases/refreshInviteToken'

export function useRefreshInviteToken() {
  const { call: refreshInviteToken, result, status } = useAsync(refreshInviteTokenUseCase)

  return { emailRecipient: result, refreshInviteTokenStatus: status, refreshInviteToken }
}
